export default {
  EXPECTED: '预计',
  DELIVERYDATE: '送达',
  SELECTED: '已选',
  PRICESPIKE: '秒杀价',
  CSF: '进口费用',
  SHIPPINGFEE: '运费',
  WECHATPAY: '微信支付',
  PROMOTION_DISCOUNT: '促销减',
  AUTHENTICITY_GUARANTEE: '正品保障',
  AMOUNT_TO: '合计',
  PAY_NOW: '立即支付',
  DEFAULT: '默认',
  MOBILE_NUMBER: '手机号码',
  KYC: '订购人',
  SELECT_KYC: '选择订购人',
  DELETE_SUCCESSFULLY: '删除成功',
  DELETE_FAILED: '删除失败',
  PLEASE_SELECT: '请选择',
  PURCHASE_CLAIM_THE_COUPON: '领券购买',
  PURCHASE_IMMEDIATELY: '立即购买',
  CONSIGNEE_NAME: '收货人姓名',
  PAYMENT_SUCCESSFUL: '已成功支付',
  VIEWORDER: '查看订单',
  AUTHORIZATION_SUCCESSFUL: '授权成功',
  REORDER: '重新下单',
  PAYMENT_RESULTS: '支付结果',
  AUTHORIZE_NOW: '立即授权',
  CANCEL_FILLING: '取消填写',
  PROVIDE_YOU: '2. 提供您的',
  COUPON_DEDUCTION: '领券减',
  CSF_DESCRIPTION: '进口服务费说明',
  I_UNDERSTAND: '我知道了',
  UPDATE_NOW: '立即更新',
  CONFIRM_ORDERS: '确认订单',
  PLEASE_PROVIDE_KYC: '请填写订购人',
  PLEASE_PROVIDE_THE_ADDRESS_INFO: '请输入详细地址',
  NAME_DO_NOT_EXCEED_20_WORDS: '收货人姓名不得超出20个字',
  ADDRESS_DO_NOT_EXCEED_100_WORDS: '详细地址不得超出100个字',
  DOTD_DISCOUNTED_PRICE: '镇店价',
  CHINESE_CUSTOMER_SERVICE: '中文客服',
  NOT_ELIGIBLE_FOR_UNCONDITIONAL_RETURN: '不支持30天无理由退货',
  PRODUCT_NOT_ELIGIBLE_FREE_SHIPPING_OVER_300RMB: '此商品不参与满300元免运费',
  TOTAL_AMOUNT_OF_PRODUCTS: '商品总价',
  UNABLE_PROVIDE_INVOICES_GLOBAL_STORE_PURCHASES: '海外购商品无法提供发票',
  CONFIRM_ORDER_CONTAINS_UNSUPPORTED_UNCONDITIONAL_RETURN:
    '确认订单含有不支持30天无理由退货的商品',
  SAVED_ON_SHIPPING_FEES: '运费省',
  PLEASE_CHECK_THE_BOX_AT_THE_BOTTOM_OF_THE_PAGE: '请在页面底部勾选订单确认',
  ADD_KYC_CUSTOMS_CLEARANCE_INFO: '添加订购人清关信息',
  ADD_KYC_INFO: '添加订购人',
  EDIT_KYC_CUSTOMS_CLEARANCE_INFO: '编辑订购人清关信息',
  TIPS_FOR_GLOBAL_STORE_SHOPPING: '海外购小贴士',
  REAL_NAME_PAYMENT_VERIFICATION_FAILED_ORDER_CANCELED:
    '购买跨境商品需清关申报和实名验证，请添加与订单付款人姓名一致的订购人清关信息。若订购人与订单付款人姓名（微信账户持有人）不一致，订单将被取消',
  ADD_CONSIGNEE_KYC: '提交收货人清关信息',
  ADD_KYC_INFO_WHEN_CLEARANCE:
    '购买跨境商品需清关申报和实名验证，请添加订单收货人清关信息。',
  KYC_SUBMIT_SUCCESS: '身份证信息提交成功，清关处理中',
  ID_CARD_NAME: '身份证姓名',
  ID_CARD_NUMBER: '身份证号码',
  ID_CARD_NUM: '身份证号',
  TAIL_NUMBER: '尾号',
  NO_KYC_PLEASE_ADD: '暂无身份证信息，请添加',
  NO_KYC: '暂无订购人信息',
  MANAGE_KYC_INFO: '管理清关信息',
  SAVE_AND_APPLY: '保存并应用',
  SELECT_SHIPPING_ADDRESS: '选择收货地址',
  PLEASE_FILL_SHIPPING_ADDRESS: '请填写收货地址',
  NO_SHIPPING_ADDRESS_FOUND_PLEASE_ADD: '暂无收货地址，请添加',
  NO_SHIPPING_ADDRESS: '暂无收货地址',
  ADD_SHIPPING_ADDRESS: '添加收货地址',
  EDIT_SHIPPING_ADDRESS: '编辑收货地址',
  PLEASE_FILL_SHIPPING_ADDRESS_FIRST: '请先填写收货地址',
  SET_AS_DEFAULT: '设为默认',
  SET_UP_SUCCESSFULLY: '设置成功',
  ADDRESS_SAVED_SUCCESSFULLY: '地址保存成功',
  SAVE_KYC_SUCCESS: '订购人保存成功',
  SUBMISSION_FAILED_PLEASE_RESUBMIT: '提交失败，请重新提交',
  MANAGE_SHIPPING_ADDRESSES: '管理收货地址',
  THIS_ORDER_SAVES_YOU: '本单为您节省',
  YOUR_ORDER_PAYMENT_FAILED: '您的订单支付失败',
  ORDERER_AND_PAYER_SHOULD_BE_SAME:
    '使用订购人清关信息时，请确保所选订购人与订单付款人（微信账户持有人）姓名一致，否则订单将被取消。',
  GLOBAL_STORE_NOTIFICATION_AND_ORDER_AUTHORIZATION: '海外购告知书及下单授权',
  CUSTOMER_AUTHENTICATION_ACKNOWLEDGE:
    '亚马逊海外购商品均由中国境外的亚马逊网站销售并发货。客户下单购买海外购商品，即表示同意不定期更新的',
  CUSTOMER_AUTHENTICATION_FOR_GS_PURCHASE:
    '并同意该购买行为受原销售地亚马逊网站适用法律的约束。为完成购买，请勾选同意以下授权：',
  USAGE_CONDITIONS: '亚马逊海外购使用条件',
  ALLOW_AMAZON_WEBSITES_COLLECT_USE_INFO_INCLUDING:
    '同意amazon.cn收集并处理客户的姓名、地址、手机号码以及身份证信息或身份证复印件，以用于清关或为符合包括外汇管制在内的法律规定。',
  INFO_WILL_USED_CLEARANCE_REAL_NAME_DECLARATION:
    '同意亚马逊海外购对应的境外销售实体Amazon Export Sales LLC获取客户亚马逊海外购账户的相关信息，以用于履行客户订单。',
  CHANGE_AUTH_STATUS_IN_MY_AFTERWARDS:
    '在“我的” > “修改海外购权限”可更改授权状态',
  ORDER_CAN_NOT_PAY_WITHOUT_AUTH: '未全部授权将无法完成订单支付',
  ONLY_X_ITEMS_LEFT_PRE_ORDER_QUICKLY: '仅剩{TOTAL}件 预购从速',
  PURCHASE_HAS_BEEN_AUTOMATICALLY_RESTRICTED: '限购自动调整数量',
  AMAZON_WILL_ESTIMATE_IMPORT_FEES_FOR_ORDER:
    '亚马逊海外购会在您下单时依清关政策为您预估并收取相关进口税费',
  SHIPPING_FEE_DESCRIPTION: '运费说明',
  LOGISTICS_AND_DELIVERY_COSTS_INCURRED_ON_ORDER:
    '您在亚马逊海外购下单后，实际产生的物流配送费用',
  PRODUCTS_HAVE_BEEN_SOLD_OUT: '商品已抢光',
  SOME_PRODUCTS_SOLD_OUT_UPDATING_THE_ORDER:
    '部分商品已抢光，更新订单可继续下单',
  ORDER_HAS_BEEN_UPDATED: '订单已更新',
  YOU_ARE_TOO_LATE: '您来晚了',
  VIEW_OTHER_PRODUCTS: '查看其他商品',
  LOOK_OTHER_ASIN: '快去逛逛其他商品',
  SOME_DISCOUNTS_HAVE_BEEN_SOLD_OUT: '部分折扣已抢光',
  UPDATING_ORDER_ALLOWS_YOU_CONTINUE_PLACING: '更新订单可继续下单',
  PLEASE_CONFIRM_THE_PURCHASE_RESTRICTION: '请确认限购',
  FAILED_TO_CREATE_THE_ORDER: '订单创建失败',
  AUTOMATIC_PURCHASE_RESTRICTION_CONFIRMATION_SUCCESSFUL: '自动限购确认成功',
  REDUCED_SHIPPING_FEE_FOR_ORDERS_OVER_THESHOLD: '运费减免后',
  VIEW_AFTER_SELECTING_AN_ADDRESS: '选择地址后查看',
  NEWCOMER_COUPON_FOR_ALL_MERCHANTS: '新人券全场',
  WECHAT_NOT_INSTALLED: '未安装微信',
  PLEASE_INSTALL_WECHAT_FIRST: '您未安装微信服务，无法完成支付，请先安装微信。',
  PROMISE_DATE_UNKWON: '预计发货日期尚未确定',
  PLEASE_FILL_NAME_CONSIGNEE: '请输入收货人姓名',
  PLEASE_DO_NOT_EXCEED_WORDS: '请勿超出{NUMS}字',
  PLEASE_USE_REAL_NAME: '请使用真实姓名',
  FILL_MOBILE_NUMBER: '请填写手机号码',
  LOCATION: '所在地区',
  FILL_ADDRESS: '填写地址',
  ADDRESS: '详细地址',
  PROVINCE_CITY_DISTRICT_STREET: '省/市/区/街道',
  PLEASE_FILL_ADDRESS: '请填写详细地址',
  SET_DEFAULT_ADDRESS: '设为默认收货地址',
  PLEASE_SELECT_REGION: '请选择所在地区',
  PLEASE_CLICK_BUTTON_FILL_SHIPPING_ADDRESS: '你还没有收货地址，请点击填写',
  PHONE_NUM_FORMAT_INCORRECT_RE_ENTER: '手机号码格式有误，请重新输入',
  SIZE_CHART: '尺码表',
  LARGE_IMAGE: '大图',
  DIFFERENT_ASIN_TYPES_LIST: '列表',
  CURRENT_PRODUCT_AVAILABLE: '当前商品可享',
  ADD_CUSTOMER_KYC_INFO: '添加订购人信息',
  PROVIDE_THE_KYC_INFO: '填写订购人',
  ONE_STEP_AWAY_FROM_ORDER: '还差一步，即可下单',
  SAME_AS_ORDER_PAYER: '同付款人姓名',
  ONLY_USED_FOR_CUSTOMER_CLEARANCE: '仅用于海外购清关',
  ID_CARD_NUM_FORMAT_INCORRECT_RE_ENTER: '身份证号码格式有误，请重新输入',
  PLEASE_ENTER_ID_CARD_NAME: '请输入身份证姓名',
  PLEASE_ENTER_ID_CARD_NUM: '请输入身份证号码',
  PLEASE_ENTER_MOBILE_NUMBER: '请输入手机号码',
  FAILED_BIND_ID_CARD_TRY_AGAIN: '绑定身份证失败，请重试',
  USUALLY_TAKES_A_FEW_DAYS_TO_ARRIVE: '海外直邮通常需要4-12天送达',
  ID_CARD_IMAGE: '身份证照片',
  UPLOAD_FRONT_CITIZEN_PHOTO: '上传身份证人像面照片',
  UPLOAD_BACK_CITIZEN_PHOTO: '上传身份证国徽面照片',
  KYC_NAME_DO_NOT_EXCEED_20_WORDS: '姓名不得超出20个字',
  SUCCESS_ADD_CART: '已加入购物车',
  PHONE_ENCRYPTED_PLEASE_RE_ENTER: '手机号已加密,请重新输入',
  ID_NUMBER_ENCRYPTED_PLEASE_RE_ENTER: '身份证号已加密，请重新输入',
  PLEASE_UPLOAD_FRONT_CITIZEN_PHOTO: '请上传身份证人像面照片',
  PLEASE_UPLOAD_BACK_CITIZEN_PHOTO: '请上传身份证国徽面照片',
  ALREADY_AUTOMATIC_PURCHASE_RESTRICTION: '已自动限购',
  ONLY_X_ITEMS_LEFT_PRE_ORDER_QUICKLY_BR: '仅剩{TOTAL}件<br />预购从速',
  ADD_CONSIGNEE_KYC_TIP:
    '政策提醒：根据海关要求，您的订单将以个人自用物品形式进行清关，需要您补充收件人身份证正反面照片或扫描件，以便您的商品能够顺利清关。',
  DOTD: '镇店之宝',
  BEST_DEAL: '特卖汇',
  FILL_INTERRUPT_PROMPT: '还差一点就填写成功了',
  NEXT_TIME: '下次再说',
  CONTINUE_FILLING: '继续填写',
  WAIT_PAYMENT_STATUS: '等待刷新支付状态',
  BEST_DEAL_PRICE: '特卖价',
  UPLOAD_SUCCESS: '已成功上传',
  UPLOAD_FAILED: '上传失败，请重试',
  SIZE_NAME: '尺码',
  COLOR_NAME: '颜色',
  FLAVOR_NAME: '口味',
  STYLE_NAME: '样式',
  SPECIAL_SIZE_TYPE: '特殊尺码',
  CUSTOMER_PACKAGE_TYPE: '商品包装类型',
  BAND_COLOR: '表带颜色',
  EDITION: '版本',
  ITEM_PACKAGE_QUANTITY: '商品包装件数',
  CONFIGURATION: '配置',
  MAXIMUM_PAYMENT_LIMIT_EXCEEDED: '已超最大支付额度',
  FAILED_TO_CREATE_ORDER: '创建订单失败'
};
